import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import cn from 'classnames';

import { Row, Col } from 'react-flexbox-grid';

import Logo from '../event_components/logo';
import Title from '../event_components/title';
import Location from '../event_components/location';
import Time from '../event_components/time';
import styles from './mobile.scss';
import GoogleLocation from '../event_components/google_location';
import AttendButton from '../event_components/attend_button';

function Mobile({ event, settings }) {
  const showLogo = settings.get('showEventLogo');
  return (
    <div className={cn(styles.mobileEvent, 'event')}>
      <Row className={styles.mobile} center="xs" middle="xs">
        {showLogo && (
          <Col xs={12} className={styles.logo}>
            <Logo event={event} className={styles.image} settings={settings} />
          </Col>
        )}
      </Row>
      <Row className={styles.content}>
        <Col xs={5}>
          <div className={styles.timeContainer}>
            <Time event={event} settings={settings} className={styles.time} format="MMM D" />
          </div>
        </Col>
        <Col xs={7}>
          <Title disableLink event={event} />
          {settings.get('calendarType') === 'google' ? (
            <GoogleLocation event={event} />
          ) : (
            <Location disableLink event={event} />
          )}
        </Col>
        {!settings.get('removeAttendButton') && (
          <AttendButton event={event} settings={settings} className={styles.attendButton} />
        )}
      </Row>
    </div>
  );
}

Mobile.propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export default Mobile;



// WEBPACK FOOTER //
// ./src/widget/event_layouts/mobile.js